// With this code we import search value on whole website
import React from "react"

import { SearchValueProvider } from "./src/context/SearchValueContext"

export const wrapRootElement = ({ element }) => (
  <SearchValueProvider>{element}</SearchValueProvider>
)
